// export default {
//   backendUri: process.env.REACT_APP_BACKEND_URI || 'http://localhost:3010',
//   authentication: {
//     clientId: process.env.REACT_APP_CLIENT_ID || '606191c4a6939341ac7459c5',
//     clientSecret: process.env.REACT_APP_CLIENT_SECRET || 'WebCheckinFrontSecret',
//     authUrl: process.env.REACT_APP_AUTH_URL || 'http://login:3000/oauth/token',
//   },
// };

// 14/01
const initEnvFlag = (envVar, defaultVal) => {
  if (envVar) {
    if (envVar === 'true' || envVar === '1') {
      return true;
    }
    if (envVar === 'false' || envVar === '0') {
      return false;
    }
  }
  return defaultVal;
};

export default {
  backendUri: process.env.REACT_APP_BACKEND_URI || 'http://localhost:3701',
  chatbotWidgetUri: process.env.REACT_APP_CHAT_WIDGET_SCRIPT_URL || 'http://localhost:5201/Widget.js',
  authentication: {
    clientId: process.env.REACT_APP_CLIENT_ID || '606191c4a6939341ac7459c5',
    clientSecret: process.env.REACT_APP_CLIENT_SECRET || 'WebCheckinFrontSecret',
    authUrl: process.env.REACT_APP_AUTH_URL || 'http://localhost:4001/oauth/token',
  },

  encryptImage: initEnvFlag(process.env.REACT_APP_ENCRYPT_IMAGE, true),
  maxImageAreaPx: parseInt(process.env.REACT_APP_IMG_MAX_AREA_PX, 10) || 1920 * 1080,
  imgSizeLimitMB: parseInt(process.env.REACT_APP_IMG_SIZE_LIMIT_MB, 10) || 5,
};

// production
// export default {
//   backendUri: process.env.REACT_APP_BACKEND_URI || 'https://api.wci.guezzt.com',
//   authentication: {
//     clientId: process.env.REACT_APP_CLIENT_ID || '5d9c66754e801f5d585f8cee',
//     clientSecret: process.env.REACT_APP_CLIENT_SECRET || 'FrontendSecret',
//     authUrl: process.env.REACT_APP_AUTH_URL || 'https://login.guezzt.com/oauth/token',
//   },
// };
